import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useChatsUIContext } from "../../../context/ChatsContext";
import { getUserId } from "../../../functions";
import { useChatDispatch, useChatSelector } from "../../../hooks/reduxHook";
import { chatsSlice } from "../../../store/chatSlice";
import { ChatListType } from "../../../types";
import { ConversationTypeEnum } from "../../../types/enums";
import ConversationInfo from "./ConversationInfo";

const { actions } = chatsSlice;

const ChatInfo = () => {
  const dispatch = useChatDispatch();
  const navigate = useNavigate();

  const [chat, setChat] = useState<ChatListType>({} as ChatListType);
  const { userInfo, selectedChat, usersMetaData } = useChatSelector(
    (state: any) => {
      return {
        userInfo: state.userInfo,
        selectedChat: state.chats.selectedChat,
        usersMetaData: state.chats.usersMetaData,
      };
    },
    shallowEqual
  );

  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
    };
  }, [chatsContext?.navigatePage]);

  const classNameDiv = `d-flex align-items-center gap-2 ${
    selectedChat?.type === ConversationTypeEnum.PERSONAL ||
    chatsUIProps?.navigatePage?.key.at(-1) === "home"
      ? "cursor-pointer"
      : ""
  }`;

  const selectUser = () => {
    if (
      selectedChat?.type === ConversationTypeEnum.PERSONAL ||
      chatsUIProps?.navigatePage?.key.at(-1) === "home"
    ) {
      navigate(
        `/profile/${
          chatsUIProps?.navigatePage?.key.at(-1) === "home"
            ? userInfo?.id
            : selectedChat?.user?.id
        }`
      );
      dispatch(actions.setChatState(false));
    }
  };

  useEffect(() => {
    let chatData = {
      ...selectedChat,
      user: selectedChat?.user,
    };
    if (chatsUIProps?.navigatePage?.key?.at(-1) === "home") {
      chatData = {
        ...userInfo,
        user: userInfo,
      };
    } else if (selectedChat?.type === ConversationTypeEnum.PERSONAL) {
      const userDataChat = usersMetaData?.[getUserId(selectedChat)];
      if (userDataChat && Object.keys(userDataChat).length > 0) {
        chatData = {
          ...selectedChat,
          user: {
            ...userDataChat,
            ...selectedChat?.user,
          },
        };
      }
    }
    setChat(chatData);
  }, [selectedChat, usersMetaData, chatsUIProps?.navigatePage]);

  return (
    <div className={classNameDiv} onClick={() => selectUser()}>
      <ConversationInfo
        type={
          chatsUIProps?.navigatePage?.key.at(-1) === "home"
            ? "home"
            : selectedChat?.type ?? ConversationTypeEnum.PERSONAL
        }
        chat={chat}
      />
    </div>
  );
};

export default ChatInfo;
